import { useState } from "react";
import { hotList } from "@/mocks/gua";

const tabs = [
  { key: "today", label: "今日" },
  { key: "week", label: "本周" },
  { key: "spread", label: "全网扩散" },
] as const;

type TabKey = keyof typeof hotList;

export default function HotRank() {
  const [active, setActive] = useState<TabKey>("today");
  const list = hotList[active];

  return (
    <section id="hot" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-line"></i>实时热度
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              今日瓜榜
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              按热度实时滚动的中心瓜排名。热度越高，说明它向外辐射的关联与衍生瓜越密集。
            </p>
          </div>

          <div className="inline-flex rounded-full border border-background-200 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === t.key
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {list.map((item) => {
            const isTop = item.rank === "01" || item.rank === "02" || item.rank === "03";
            return (
              <article
                key={item.rank + item.title}
                className="group flex flex-col gap-4 rounded-xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200 hover:bg-background-50 md:flex-row md:items-center md:px-5"
              >
                <div className="flex items-center gap-4 md:w-[68px]">
                  <span
                    className={`font-heading text-2xl font-black ${
                      isTop ? "text-primary-500" : "text-background-400"
                    }`}
                  >
                    {item.rank}
                  </span>
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap rounded bg-secondary-200 px-2 py-0.5 text-xs font-medium text-secondary-900">
                      {item.cat}
                    </span>
                    <span className="whitespace-nowrap text-xs text-accent-700">
                      中心瓜：{item.center}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                </div>

                <div className="flex flex-wrap items-center gap-x-5 gap-y-2 md:justify-end">
                  <div className="flex items-center gap-1.5 text-sm font-semibold text-foreground-800">
                    <i className="ri-fire-line text-accent-500"></i>
                    {item.heat}
                  </div>
                  <div className="hidden flex-col items-end text-xs text-foreground-500 lg:flex">
                    <span>{item.related}</span>
                    <span>{item.trend}</span>
                  </div>
                  <span
                    className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${
                      item.rising
                        ? "bg-primary-100 text-primary-700"
                        : "bg-secondary-200 text-secondary-700"
                    }`}
                  >
                    <i className={item.rising ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                    {item.delta}
                  </span>
                </div>
              </article>
            );
          })}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-500">
          榜单每 30 分钟按全网热度更新一次，数据仅供参考，请以多方核实信息为准。
        </p>
      </div>
    </section>
  );
}